<div class="border-2 border-blue-500 border-round border-black p-3 m-auto lg:w-7">
  <div>
    <p class="text-red-500 text-center">
      {{noContent}}
    </p>
  </div>
</div>
